import PropTypes from 'prop-types';
import React, { Component, PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import Spinner from './../../reusable/Spinner/Spinner';
import TableHeader from './Components/TableHeader';
import TableRow from './Components/TableRow';

class LightTable extends Component {
    static propTypes = {
        pageSize: PropTypes.number,
        headerItems: PropTypes.array,
        listItems: PropTypes.array,
        noEntries: PropTypes.func,
        className: PropTypes.string,
        headerWidth: PropTypes.number
    };

    static defaultProps = {
        headerItems: null,
        listItems: null,
        className: "",
        noEntries: () => (
            <div className="rmm-no-entries">
                <FormattedMessage id="General_CoreFunctionality_UIText_general.nothingToDisplay" />
            </div>
        ),
        headerWidth: null
    };

    render() {
        if (this.props.listItems && this.props.listItems.length === 0) {
            return (<div className="light-table">
                <TableHeader headers={this.props.headerItems} width={this.props.headerWidth} />
                {this.props.noEntries()}
            </div>);
        } else {
            const rows = this.props.listItems && this.props.listItems.map((item, index) =>
                <TableRow headerItems={this.props.headerItems} item={item} key={index}/>)

            return (
                <div className={"light-table " + this.props.className}>
                    <TableHeader headers={this.props.headerItems} width={this.props.headerWidth} />
                    <div className="light-table__headers__placeholder" />
                    <Spinner isLoading={this.props.listItems === null}>
                        <div className="light-table__rows">{rows}</div>
                    </Spinner>
                </div>
            )
        }
    }
}

export default LightTable;


// WEBPACK FOOTER //
// ./src/scripts/reusable/LightTable/VeryLightTable.jsx